import CartModal from './cart-modal';

export default CartModal;